import React from 'react';
import { Flex, Box, Text, Heading } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import SpannedText from '@pages/UploadSellout/components/spannedText';
import ReminderIllustration from '@pages/UploadSellout/assets/reminderIllustration';

const Reminder = () => {
    const navigate = useNavigate();

    const scrollToHistory = () => {
        const elHistory = document.getElementById('history__upload-sellout');
        if (!elHistory) return;

        elHistory.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        });
    };

    return (
        <Box
            borderRadius={'8px'}
            overflow="hidden"
            bg={'semantic.100'}
            boxShadow={'0px 1px 3px 0px hsla(0, 0%, 0%, 0.10)'}
            mb={'40px'}
        >
            <Flex>
                <Box flexShrink={0}>
                    <ReminderIllustration />
                </Box>

                <Flex flexDir={'column'} justifyContent={'center'} p="16px 60px" gap="8px">
                    <Heading fontSize={'24px'} mb={'12px'} color={'sagitarius.500'}>
                        Upload Data Sell Out Disini.
                    </Heading>
                    <Text fontSize={'14px'}>
                        Upload dan lacak kelengkapan data Sell Out melalui
                        <SpannedText onClick={scrollToHistory}>riwayat</SpannedText> atau
                        <SpannedText onClick={() => navigate('/audit-trail')}>audit trail.</SpannedText> Pastikan untuk
                        upload seluruh data brand sesuai dengan perjanjian. Terima kasih atas kerjasamannya!
                    </Text>
                </Flex>
            </Flex>
        </Box>
    );
};

export default Reminder;
